import Player from "./Player";

// create a singleton instance of player
export const player = new Player();
